import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Layout from './components/layout/Layout';
import About from './pages/About';
import Admission from './pages/Admission';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import ProgramsAndCourses from './pages/ProgramsAndCourses';
import Login from './pages/Login';
import Blog from "./pages/Blog";
import BlogSingleView from "./pages/BlogSingleView";
import AdmissionForm from './pages/AdmissionForm';
import Webinars from './pages/Webinars';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="/about" element={<About />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/services" element={<Services />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/programs-and-courses' element={<ProgramsAndCourses />} />
          <Route path='/login' element={<Login />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog-detailed' element={<BlogSingleView />} />
          <Route path='/admission-form' element={<AdmissionForm />} />
          <Route path='/webinars' element={<Webinars />} />

          {/* not found */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
